import { wagRunningResultCompare } from "./common";

export const parseUpdMatchRes = (message, topicInfo, contentRef) => {
    if(contentRef.current.matchData != null) {
        let match = null;
        match = contentRef.current.matchData.matches.find(x => x.tournament.id===topicInfo.tournamentid && x.id === topicInfo.matchid);
        let rawMatch = null;
        rawMatch = contentRef.current.rawMatchList.find(x => x.tournament.id===topicInfo.tournamentid && x.id === topicInfo.matchid)
        if(rawMatch != null){
            if(rawMatch.runningResult == null){

                let runRes ={
                    awayScore : 0,
                    homeScore : 0,
                    corner : 0,
                    awayCorner: 0,
                    homeCorner: 0
                }
                
                let runningResArr= message.wgrRes.res.filter(x => x.stageId == 2 || x.stageId == 3 || x.stageId == 4 || x.stageId == 5); //running result stageId = 2-5
                let hrResArr = runningResArr.filter(x=> x.resTyp ==1).sort(wagRunningResultCompare);  // resTyp==1 for awayScore and homeScore
                let cornerResArr =  runningResArr.filter(x=> x.resTyp ==2).sort(wagRunningResultCompare); // resTyp==2 for corner
             
                if(hrResArr.length>0){
                    let hrResArrLen = hrResArr.length;
                    runRes.awayScore = hrResArr[hrResArrLen-1].aRes;
                    runRes.homeScore = hrResArr[hrResArrLen-1].hRes;
                }
                if(cornerResArr.length>0){
                    let cornerResArrLen = cornerResArr.length;
                    runRes.corner = cornerResArr[cornerResArrLen-1].aRes + cornerResArr[cornerResArrLen-1].hRes; //corner = hRes+aRes
                    runRes.awayCorner = cornerResArr[cornerResArrLen-1].aRes
                    runRes.homeCorner = cornerResArr[cornerResArrLen-1].hRes
                }
                rawMatch.runningResult = runRes;
                if(match){
                    match.runningResult = runRes;
                }
            }
            else{
                let runningResArr= message.wgrRes.res.filter(x => x.stageId == 2 || x.stageId == 3 || x.stageId == 4 || x.stageId == 5); //running result stageId = 2-5
                let hrResArr = runningResArr.filter(x=> x.resTyp ==1).sort(wagRunningResultCompare);  // resConfirmTyp==1 for awayScore and homeScore
                let cornerResArr =  runningResArr.filter(x=> x.resTyp ==2).sort(wagRunningResultCompare); // resConfirmTyp==2 for corner

                if(hrResArr.length>0){
                    let hrResArrLen = hrResArr.length;
                    rawMatch.runningResult.awayScore = hrResArr[hrResArrLen-1].aRes;
                    rawMatch.runningResult.homeScore = hrResArr[hrResArrLen-1].hRes;
                }else{
                    rawMatch.runningResult.awayScore = 0
                    rawMatch.runningResult.homeScore = 0
                }
                if(cornerResArr.length>0){
                    let cornerResArrLen = cornerResArr.length;
                    rawMatch.runningResult.corner = cornerResArr[cornerResArrLen-1].aRes + cornerResArr[cornerResArrLen-1].hRes; //corner = hRes+aRes
                    rawMatch.runningResult.awayCorner = cornerResArr[cornerResArrLen-1].aRes
                    rawMatch.runningResult.homeCorner = cornerResArr[cornerResArrLen-1].hRes
                }else{
                    rawMatch.runningResult.corner  = 0
                    rawMatch.runningResult.awayCorner = 0
                    rawMatch.runningResult.homeCorner = 0
                }
                if(match){
                    match.runningResult =  rawMatch.runningResult;
                }
            }
            let runningResExtArr= message.wgrRes.res.filter(x => x.stageId == 6 || x.stageId == 7 || x.stageId == 8 || x.stageId == 9); //running extra result stageId = 6-9
            if(runningResExtArr.length > 0){
                if(rawMatch.runningResultExtra == null){
    
                    let runResExt ={
                        awayScore : 0,
                        homeScore : 0,
                        corner : 0,
                        awayCorner: 0,
                        homeCorner: 0
    
                    }
                    
                    let hrResExtArr = runningResExtArr.filter(x=> x.resTyp ==1).sort(wagRunningResultCompare);  // resTyp==1 for awayScore and homeScore
                    let cornerExtResArr =  runningResExtArr.filter(x=> x.resTyp ==2).sort(wagRunningResultCompare); // resTyp==2 for corner
    
              
                    if(hrResExtArr.length>0){
                        let hrResExtArrLen = hrResExtArr.length;
                        runResExt.awayScore = hrResExtArr[hrResExtArrLen-1].aRes;
                        runResExt.homeScore = hrResExtArr[hrResExtArrLen-1].hRes;
                    }
                    if(cornerExtResArr.length>0){
                        let cornerResExtArrLen = cornerExtResArr.length;
                        runResExt.corner = cornerExtResArr[cornerResExtArrLen-1].aRes + cornerExtResArr[cornerResExtArrLen-1].hRes; //corner = hRes+aRes
                        runResExt.awayCorner = cornerExtResArr[cornerResExtArrLen-1].aRes
                        runResExt.homeCorner = cornerExtResArr[cornerResExtArrLen-1].hRes
                    }
                    rawMatch.runningResultExtra = runResExt;
                    // console.debug("runResExt",runResExt);
    
    
                }
                else{
                    // let runningResExtArr= message.wgrRes.res.filter(x => x.stageId == 6 || x.stageId == 7 || x.stageId == 8 || x.stageId == 9); //running result stageId = 2-5
                    let hrResExtArr = runningResExtArr.filter(x=> x.resTyp ==1).sort(wagRunningResultCompare);  // resConfirmTyp==1 for awayScore and homeScore
                    let cornerResExtArr =  runningResExtArr.filter(x=> x.resTyp ==2).sort(wagRunningResultCompare); // resConfirmTyp==2 for corner
    
                    if(hrResExtArr.length>0){
                        let hrResArrExtLen = hrResExtArr.length;
                        rawMatch.runningResultExtra.awayScore = hrResExtArr[hrResArrExtLen-1].aRes;
                        rawMatch.runningResultExtra.homeScore = hrResExtArr[hrResArrExtLen-1].hRes;
                    }else{
                        rawMatch.runningResultExtra.awayScore = 0
                        rawMatch.runningResultExtra.homeScore = 0
                    }
                    if(cornerResExtArr.length>0){
                        let cornerResExtArrLen = cornerResExtArr.length;
                        rawMatch.runningResultExtra.corner = cornerResExtArr[cornerResExtArrLen-1].aRes + cornerResExtArr[cornerResExtArrLen-1].hRes; //corner = hRes+aRes
                        rawMatch.runningResultExtra.awayCorner = cornerResExtArr[cornerResExtArrLen-1].aRes
                        rawMatch.runningResultExtra.homeCorner = cornerResExtArr[cornerResExtArrLen-1].hRes
                    }else{
                        rawMatch.runningResultExtra.corner = 0
                        rawMatch.runningResultExtra.awayCorner = 0
                        rawMatch.runningResultExtra.homeCorner = 0
                    }
    
                }
            }
        }
        if(contentRef.current.isESContent && match){
            match.results = message?.wgrRes?.res?.map(item => {
                return {
                    "sequence": item?.seqNo,
                    "resultType": item?.resTyp,
                    "stageId": item?.stageId,
                    "homeResult": item?.hRes,
                    "awayResult": item?.aRes,
                    "resultConfirmType": item?.resConfirmTyp,
                    "payoutConfirmed": item?.payoutConfirmed
                }
            })
        }
        
        if(match){
            match.runningResult =  rawMatch.runningResult;
            match.runningResultExtra =  rawMatch.runningResultExtra;
        }
    }
}